import { useNavigate } from "@tanstack/react-router";
import { useMockAuth, exitImpersonation, getUser } from "@/lib/mock-auth";
import { organizations } from "@/mocks/saas-data";

export function ImpersonationBanner() {
  const navigate = useNavigate();
  const { session } = useMockAuth();
  if (!session?.impersonating) return null;
  const original = getUser(session.impersonating.originalUserId);
  const org = organizations.find((o) => o.id === session.impersonating?.orgId);
  return (
    <div className="flex items-center justify-between gap-3 border-b border-amber-500/30 bg-amber-400/15 px-4 py-2 text-xs">
      <span>
        <span className="font-mono uppercase tracking-widest text-amber-700 dark:text-amber-300">Impersonating</span>{" "}
        <span className="font-medium">{org?.name ?? "organization"}</span>
        {original ? <span className="text-muted-foreground"> · superadmin {original.email}</span> : null}
      </span>
      <button
        onClick={() => {
          exitImpersonation();
          navigate({ to: "/admin/organizations", replace: true });
        }}
        className="rounded-md bg-foreground px-2.5 py-1 text-[11px] font-medium text-background hover:opacity-90"
      >
        Exit impersonation
      </button>
    </div>
  );
}
